import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {AutenticacaoService} from '../services/autenticacao.service';
import {UtilsService} from '../utils/utils.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private _auth: AutenticacaoService, private _router: Router, private _utils: UtilsService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(resolve => {
      if (this._utils.getUsuario() && this._auth.getToken()) {
        resolve(true);
        return;
      }
      resolve(false);
      this._router.navigateByUrl('/login');
    });
  }
}
